import React from 'react';
import PinIcon from '../location-dot-solid-full.svg';

function CurrentLocation(props) {
    const { className = '', location, onClick } = props;

    return (
        <div className={className} onClick={onClick}>
            <PinIcon />
            <strong>{location?.name}</strong>
        </div>
    );
}

export default CurrentLocation;
